import { api } from "./api";

export const getDogById = async (dogId: string, personId: number): Promise<any> => {    
    const { data } = await api.get<object>(`/Dog?dogId=${encodeURIComponent(dogId.trim())}&personId=${personId}`);

    return data;
};

export const getDogShowResultsById = async (dogId: string, personId: number): Promise<any> => {    
    const { data } = await api.get<object>(`/Dog/showresults?dogId=${encodeURIComponent(dogId.trim())}&personId=${personId}`);

    return data;
};

export const getDogLeases = async (dogId: string): Promise<any> => {    
    const { data } = await api.get<object>(`/Dog/leases?dogId=${encodeURIComponent(dogId.trim())}`);

    return data;
};

export const changeDogFavoriteStatus = async (dogId: string, personId: number): Promise<any> => {
    const { data } = await api.post<object>(`/Dog/updateDogFavoriteStatus`, { dogId, personId } );

    return data;
}

export const updateMyDog = async (dogId: string, details: {
    callName: string | null;
    chipNumber: string | null;
    isDeceased: boolean;
    deathDate: string | null;
    isInactive: boolean;
}): Promise<any> => {
    const { data } = await api.post<any>(`/Dog/${encodeURIComponent(dogId.trim())}/details`, details);

    return data;
};

export const uploadDogPhoto = async (dogId: string, photo: Blob, acceptedTerms: string): Promise<any> => {
    const form = new FormData();
    form.append("photo", photo, (photo as File).name || "photo.jpg");
    form.append("acceptedTerms", acceptedTerms);

    // The shared api instance defaults to application/json; the browser must set the
    // multipart boundary itself, so the header is cleared for this request only.
    const { data } = await api.post<any>(`/DogPhoto/${encodeURIComponent(dogId.trim())}`, form as any, {
        headers: { "Content-Type": undefined },
    });

    return data;
};

export const deleteDogPhoto = async (dogId: string): Promise<any> => {
    const { data } = await api.delete<any>(`/DogPhoto/${encodeURIComponent(dogId.trim())}`);

    return data;
};

export const getDogTitlesById = async (dogId: string): Promise<any> => {    
    const { data } = await api.get<object>(`/Dog/titles?dogId=${encodeURIComponent(dogId.trim())}`);

    return data;
};
  
export default {
    updateMyDog,
    uploadDogPhoto,
    deleteDogPhoto,
    getDogById,
    getDogShowResultsById,
    getDogLeases,
    changeDogFavoriteStatus,
    getDogTitlesById,
};